import { useLocation } from "react-router-dom";
import useFirebaseAuth from "shared/hooks/useFirebaseAuth";
import useFirestore from "shared/hooks/useFirestore";
import { ChangeEvent, useEffect, useState } from "react";
import useGetBranchId from "shared/hooks/useGetBranchId";
import { TeacherInputs } from "shared/types/teacher";

const useAccountRegister = () => {
    const { createAccount } = useFirebaseAuth();
    const id = useLocation().state;
    const {getBranchId} = useGetBranchId();
    const { writeFirestore, readFirestoreOneDoc, updateFirestore, deleteFirestore } = useFirestore();
    const [isError, setIsError] = useState(false);
    const [isSucceed, setIsSucced] = useState(false);
    const [isDuplicated, setIsDuplicated] = useState<boolean | null>(null);
    const [isOpenPasswordModal, setIsOpenPasswordModal] = useState(false);
    const [isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal] = useState(false)
    const [isOpenDuplicatedModal, setIsOpenDuplicatedModal] = useState(false);
    const [isOpenNullModal, setIsOpenNullModal] = useState(false);
    const [teacherInput, setTeacherInputs] = useState<TeacherInputs>({
        name: "",
        tel: "",
        id: "",
        password: "",
        password_check: "",
        email: "",
        address: ""
    })

    useEffect(() => {
        if(id){
            getData();
        }
        // eslint-disable-next-line
    }, [id])

    const getData = async() => {
        readFirestoreOneDoc("User/Auth/Teacher", id).then(res => {
            if(res.exists()){
                const data = res.data();
                setTeacherInputs({
                    name: data.name,
                    tel: data.tel,
                    id: data.id,
                    password: data.pw,
                    password_check: data.pw,
                    email: data.email,
                    address: data.address
                })
            }
        })
    }

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        setTeacherInputs({
            ...teacherInput,
            [name]: value
        })
    }

    const onSaveButtonClick = () => {
        if(id){
            update();
        }else{
            register();
        }
    }

    const register = async() => {
        const name = teacherInput.name.trim();
        const id = teacherInput.id.trim();
        const password = teacherInput.password.trim();
        const password_check = teacherInput.password_check.trim();
        const tel = teacherInput.tel.trim();
        const email = teacherInput.email.trim();
        const address = teacherInput.address.trim();

        if(!(id && password && password_check && name)){
            setIsOpenNullModal(true);
            return;
        }
        if(isDuplicated || isDuplicated === null){
            setIsOpenDuplicatedModal(true);
            return;
        }
        if(password !== password_check){
            setIsOpenPasswordModal(true);
            return;
        }
        const res = await createAccount(`${id}@toss.kr`, password);
        if(res === null){
            setIsError(true);
            return;
        }

        const branch_id = await getBranchId();

        const teacher_data = {
            id: id,
            pw: password,
            register_date: new Date(),
            name: name,
            tel: tel,
            email: email,
            address: address,
            branch_id: branch_id,
        }

        writeFirestore("User/Auth/Teacher", res.uid, teacher_data).then(res => {
            if(res){
               setIsSucced(true);
            }
        })
        writeFirestore("User/Auth/Log", res.uid, teacher_data).then(res => {
            if(res){
               setIsSucced(true);
            }
        })
    }

    const update = () => {
        const name = teacherInput.name.trim();
        const tel = teacherInput.tel.trim();
        const email = teacherInput.email.trim();
        const address = teacherInput.address.trim();

        if(!(name)){
            setIsOpenNullModal(true);
            return;
        }

        const update_data = {
            name: name,
            tel: tel,
            email: email,
            address: address
        }

        updateFirestore("User/Auth/Teacher", id, update_data).then(res =>{
            if(res){
                setIsSucced(true);
            }
        })
    }

    const onDeleteClickHandler = async() => {
        deleteFirestore(`User/Auth/Teacher`, id).then(res => {
          if(res){
            setIsOpenDeleteSucceedModal(true);
          }
        })
    }

    return {teacherInput, onChange, onSaveButtonClick, isError, setIsError, isSucceed, setIsDuplicated, 
        isOpenPasswordModal, setIsOpenPasswordModal, isOpenDuplicatedModal, setIsOpenDuplicatedModal,
        isOpenNullModal, setIsOpenNullModal,
        isOpenDeleteSucceedModal, setIsOpenDeleteSucceedModal, onDeleteClickHandler
    }
}

export default useAccountRegister;